import { createServerFn } from "@tanstack/react-start"
import { getMyEvents as getMyEventsService, toggleAttend as toggleAttendService } from "@apps/gwservice/events"
import { likePost as likePostService } from "@apps/gwservice/meta"
import { getPartners as getPartnersService } from "@apps/gwservice/partners"
import { getPostsFeed as getPostsFeedService } from "@apps/gwservice/posts"
import { withAuth } from "../../auth/server/auth"
import { Result } from "@praha/byethrow"

export const getPostsFeed = createServerFn({
  method: "GET",
})
  .inputValidator((data: { page?: number }) => data)
  .handler(({ data }) => Result.try({
    try: () => withAuth(getPostsFeedService)(data.page),
    catch: () => "unexpected server error",
  }))

export const getPartners = createServerFn({
  method: "GET",
})
  .inputValidator((data: { limit: number }) => data)
  .handler(({ data }) => Result.try({
    try: () => getPartnersService(data.limit),
    catch: () => "unexpected server error",
  }))

export const getMyEvents = createServerFn({
  method: "GET",
}).handler(() => Result.try({
  try: () => withAuth(getMyEventsService)(),
  catch: () => "unexpected server error",
}))

export const toggleAttend = createServerFn({
  method: "POST",
})
  .inputValidator((data: { eventId: number }) => data)
  .handler(({ data }) => Result.try({
    try: () => withAuth(toggleAttendService)(data.eventId),
    catch: () => "unexpected server error",
  }))

export const likePost = createServerFn({
  method: "POST",
})
  .inputValidator((data: { postId: number; liked: boolean }) => data)
  .handler(({ data }) => Result.try({
    try: () => withAuth(likePostService)(data.postId, data.liked),
    catch: () => "unexpected server error",
  }))
